/** List of vendor-prefixed fullscreen change event names */
const FULLSCREEN_CHANGE_EVENTS = [
    "fullscreenchange",
    "webkitfullscreenchange",
    "mozfullscreenchange",
    "MSFullscreenChange",
] as const

/** Adds a fullscreen change event listener that works across different browsers */
export const addFullscreenChangeListener = (handler: () => void): void => {
    FULLSCREEN_CHANGE_EVENTS.forEach((eventName) => {
        document.addEventListener(eventName, handler)
    })
}

/** Removes a fullscreen change event listener */
export const removeFullscreenChangeListener = (handler: () => void): void => {
    FULLSCREEN_CHANGE_EVENTS.forEach((eventName) => {
        document.removeEventListener(eventName, handler)
    })
}

/** Handles entering fullscreen mode with cross-browser compatibility */
export const enterDeviceFullscreen = (element: HTMLElement | null): void => {
    if (!element) return

    if (element.requestFullscreen) {
        element.requestFullscreen()
    } else if ((element as any).webkitRequestFullscreen) {
        ;(element as any).webkitRequestFullscreen()
    } else if ((element as any).msRequestFullscreen) {
        ;(element as any).msRequestFullscreen()
    }
}

/** Handles exiting fullscreen mode with cross-browser compatibility */
export const exitDeviceFullscreen = (): void => {
    if (document.fullscreenElement) {
        document.exitFullscreen()
    } else if ((document as any).webkitFullscreenElement) {
        ;(document as any).webkitExitFullscreen()
    } else if ((document as any).mozFullScreenElement) {
        ;(document as any).mozCancelFullScreen()
    } else if ((document as any).msFullscreenElement) {
        ;(document as any).msExitFullscreen()
    }
}

/** Checks if the browser is currently in fullscreen mode */
export const isDeviceFullscreen = (): boolean => {
    return Boolean(
        document.fullscreenElement ||
            (document as any).webkitFullscreenElement ||
            (document as any).mozFullScreenElement ||
            (document as any).msFullscreenElement,
    )
}
